import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/i18n";

export default function Footer() {
  const { t, lang } = useI18n();
  const base = `/${lang}`;
  const year = new Date().getFullYear();

  const openCookieSettings = () => {
    try { localStorage.removeItem("xorzeni.consent.v2"); } catch (e) {}
    window.dispatchEvent(new Event("xorzeni:reopen-consent"));
  };

  return (
    <footer className="bg-[var(--brand-navy)] text-white" data-testid="site-footer">
      <div className="max-w-[1240px] mx-auto px-6 lg:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <span className="inline-flex items-center justify-center w-9 h-9 border border-white/40">
                <span className="font-serif-brand text-lg font-semibold">X</span>
              </span>
              <span className="font-serif-brand text-xl font-semibold">Xorzeni</span>
            </div>
            <p className="text-sm text-white/70 leading-relaxed">{t("footer.about")}</p>
          </div>

          <div>
            <h4 className="font-mono-brand text-[11px] uppercase tracking-[0.24em] text-white/50 mb-4">{t("footer.nav")}</h4>
            <ul className="space-y-3 text-sm text-white/85">
              <li><Link to={base} className="hover:text-white" data-testid="footer-link-home">{t("nav.home")}</Link></li>
              <li><a href={`${base}#plataforma`} className="hover:text-white" data-testid="footer-link-about">{t("nav.about")}</a></li>
              <li><a href={`${base}#sectores`} className="hover:text-white" data-testid="footer-link-sectors">{t("nav.sectors")}</a></li>
              <li><a href={`${base}#proceso`} className="hover:text-white" data-testid="footer-link-process">{t("nav.process")}</a></li>
              <li><a href={`${base}#newsletter`} className="hover:text-white" data-testid="footer-link-newsletter">{t("nav.newsletter")}</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-mono-brand text-[11px] uppercase tracking-[0.24em] text-white/50 mb-4">{t("footer.legal")}</h4>
            <ul className="space-y-3 text-sm text-white/85">
              <li><Link to={`${base}/privacy-policy`} className="hover:text-white" data-testid="footer-link-privacy">{t("pages.privacy.title")}</Link></li>
              <li><Link to={`${base}/cookie-policy`} className="hover:text-white" data-testid="footer-link-cookie">{t("pages.cookie.title")}</Link></li>
              <li><Link to={`${base}/terms-conditions`} className="hover:text-white" data-testid="footer-link-terms">{t("pages.terms.title")}</Link></li>
              <li>
                <button type="button" onClick={openCookieSettings} className="hover:text-white text-left" data-testid="footer-link-cookie-settings">
                  {t("cookieBanner.title")}
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-mono-brand text-[11px] uppercase tracking-[0.24em] text-white/50 mb-4">{t("footer.contact")}</h4>
            <address className="not-italic space-y-2 text-sm text-white/85 leading-relaxed">
              <div>{t("footer.address")}</div>
              <div>
                <a href={`mailto:${t("footer.email")}`} className="hover:text-white underline decoration-white/30" data-testid="footer-email">{t("footer.email")}</a>
              </div>
              <div>
                <a href={`tel:${t("footer.phone").replace(/\s/g, "")}`} className="hover:text-white" data-testid="footer-phone">{t("footer.phone")}</a>
              </div>
            </address>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/15 grid grid-cols-1 lg:grid-cols-3 gap-6 text-xs text-white/60 leading-relaxed">
          <div>
            <div className="text-white/80 font-medium mb-1">{t("footer.legalDetails")}</div>
            <div>{t("footer.companyName")}</div>
            <div>{t("footer.registration")}</div>
            <div>{t("footer.taxId")}</div>
          </div>
          <div>
            <div className="text-white/80 font-medium mb-1">{t("footer.licenses").split("·")[0].trim()}</div>
            <div>{t("footer.licenses")}</div>
            <div className="mt-2">{t("footer.incorporated")}</div>
          </div>
          <div>
            <div className="text-white/80 font-medium mb-1">{t("footer.jurisdiction").split(":")[0]}</div>
            <div>{t("footer.jurisdiction")}</div>
            <div className="mt-2">{t("footer.disclaimer")}</div>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-white/10 flex flex-col md:flex-row justify-between gap-3 text-xs text-white/50">
          <div>© {year} {t("footer.companyName")}. {t("footer.rights")}</div>
          <div className="font-mono-brand tracking-[0.2em] uppercase">xorzeni.com · {t("common.argentina")}</div>
        </div>
      </div>
    </footer>
  );
}
